import { useMemo } from "react"
import { derivePlayerStanding } from "@/hooks/usePlayerStanding/helpers"
import { IPlanPresence, IPlayerStanding } from "@/hooks/usePlayerStanding/types"
import {
  useGetActiveMapQuery,
  useGetMovementStateQuery,
  useGetPlayerWorldStateQuery
} from "@/store/apis/worldMapAPI"

export const usePlayerStanding = (): IPlayerStanding => {
  const { plan } = useGetMovementStateQuery(undefined, {
    selectFromResult: ({ data }): { plan: IPlanPresence } => ({
      plan:
        data === undefined ? "not-loaded" : data === null ? "absent" : "present"
    })
  })
  const me = useGetPlayerWorldStateQuery(undefined, {
    selectFromResult: ({ data }) => ({
      x: data?.x,
      y: data?.y,
      meMapId: data?.mapId,
      snapshotMoving: Boolean(data?.movement)
    })
  })
  const { activeMapId } = useGetActiveMapQuery(undefined, {
    selectFromResult: ({ data }) => ({ activeMapId: data?.id })
  })
  const mapId = me.meMapId ?? activeMapId
  return useMemo(
    () =>
      derivePlayerStanding({
        plan,
        snapshotMoving: me.snapshotMoving,
        standing:
          me.x === undefined || me.y === undefined || mapId === undefined
            ? null
            : { mapId, x: me.x, y: me.y }
      }),
    [plan, me.snapshotMoving, me.x, me.y, mapId]
  )
}
